import script from "./AnnounceRequirementModel.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnounceRequirementModel.vue?vue&type=script&setup=true&lang=js"

import "./AnnounceRequirementModel.vue?vue&type=style&index=0&id=5d350022&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d350022"]])

export default __exports__